import { cn } from '@/lib/utils'

/** Framer-style toggle button group — replaces dropdown selects for few options */
export function ToggleGroup({
  value,
  onChange,
  options,
}: {
  value: string
  onChange: (value: string) => void
  options: { label: string; value: string; icon?: React.ComponentType<{ className?: string }> }[]
}) {
  return (
    <div className="inline-flex rounded-xl border border-input bg-background p-0.5 gap-0.5">
      {options.map((opt) => {
        const isActive = value === opt.value
        const Icon = opt.icon
        return (
          <button
            key={opt.value}
            type="button"
            className={cn(
              'inline-flex items-center justify-center gap-1 rounded-sm px-2 py-1 text-[11px] font-medium transition-colors',
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
            onClick={() => onChange(opt.value)}
            title={opt.label}
          >
            {Icon ? <Icon className="h-3.5 w-3.5" /> : opt.label}
          </button>
        )
      })}
    </div>
  )
}
